import ObserversConnected from './ObserversConnected'

export default ObserversConnected
